import { render, staticRenderFns } from "./notificationarea.vue?vue&type=template&id=0dc684d8&scoped=true&"
import script from "./notificationarea.vue?vue&type=script&lang=js&"
export * from "./notificationarea.vue?vue&type=script&lang=js&"
import style0 from "./notificationarea.vue?vue&type=style&index=0&id=0dc684d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc684d8",
  null
  
)

export default component.exports